import { c as _c } from "react/compiler-runtime";
export default function XIcon() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg className="tw-w-full tw-h-full tw-rounded-full tw-ring-1 tw-ring-white/20 tw-align-top" viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="45" cy="45" r="45" fill="#111111" /><path d="M49.4463 41.3143L66.6146 21H62.5463L47.639 38.6386L35.7326 21H22L40.0048 47.6727L22 68.9754H26.0686L41.811 50.3484L54.385 68.9754H68.1176L49.4453 41.3143H49.4463ZM43.8738 47.9077L42.0495 45.2517L27.5345 24.1176H33.7836L45.4974 41.1735L47.3217 43.8295L62.5482 65.9995H56.2991L43.8738 47.9087V47.9077Z" fill="white" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}